import { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import compose from 'lodash/flowRight';
import reject from 'lodash/reject';
import ConfirmButton from '../confirm-button';
import consumeAppContext from '../../consumers/app';
import { removeGroupMemberMutation, groupMembersQuery } from '../../apollo/groups';

const GroupMemberRemoveButton = ({ member, removeGroupMember, loggedInUser }) => {
  const [submitting, setSubmitting] = useState(false);

  // can't update yourself
  if (!loggedInUser || member.user.id === loggedInUser.id) {
    return null;
  }

  return (
    <ConfirmButton
      onClick={() => {
        setSubmitting(true);
        removeGroupMember({
          variables: {
            id: member.id
          }
        }).then(() => setSubmitting(false));
      }}
      disabled={submitting}
      label="Remove Member"
      confirmMessage={`Are you sure you would like to remove ${member.user.displayName} from this group?`}
      size="small"
    />
  );
};

GroupMemberRemoveButton.propTypes = {
  group: PropTypes.object,
  member: PropTypes.object,
  removeGroupMember: PropTypes.func,
  loggedInUser: PropTypes.object
};

export default compose(
  consumeAppContext,
  graphql(removeGroupMemberMutation, {
    name: 'removeGroupMember',
    options: ({ group }) => ({
      update: (proxy, { data: { removeGroupMember: groupMember } }) => {
        const queryVariables = {
          slug: group.slug
        };
        const data = proxy.readQuery({
          query: groupMembersQuery,
          variables: queryVariables
        });
        proxy.writeQuery({
          query: groupMembersQuery,
          variables: queryVariables,
          data: {
            ...data,
            group: {
              ...data.group,
              members: reject(data.group.members, ({ id }) => id === groupMember.id)
            }
          }
        });
      }
    })
  })
)(GroupMemberRemoveButton);
